"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronDown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
exports.ChevronDown = react_1.default.memo(function (_a) {
    var color = _a.color, isSelected = _a.isSelected, isDisabled = _a.isDisabled;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !isSelected || isDisabled ? ((0, jsx_runtime_1.jsx)("path", { xmlns: "http://www.w3.org/2000/svg", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "M5.333 10.667L16 21.333l10.667-10.666" })) : ((0, jsx_runtime_1.jsx)("path", { xmlns: "http://www.w3.org/2000/svg", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2.5", d: "M5.333 10.667L16 21.333l10.667-10.666" })) }));
});
